import { $, $$, onReady } from '../nth-ms26-core/js/env';
import { fetchCmsHtml, toFragment } from '../nth-ms26-core/js/ajax';
import { ratio } from '../nth-ms26-core/js/scale';

/*
 * Trang danh sách tin: phân trang + đổi danh mục.
 * - Mọi nút là <a href> thật (/news/<cate>.<page>.html) → Google lần được hết trang, tắt JS vẫn dùng được.
 * - Có JS: gọi AJAX (server trả chuỗi JSON chứa danh sách + 3 input ẩn), thay danh sách tại chỗ,
 *   đổi URL bằng pushState để F5/chia sẻ link vẫn đúng trang; nút Back trình duyệt hoạt động.
 */
const WINDOW = 5;

onReady(() => {
  const pager = $('[data-pager]');
  const results = $('[data-list-results]');
  if (!pager || !results) return;

  const urlTpl = pager.dataset.url || '';
  const endpointTpl = (pager.dataset.endpoint || '').trim();
  const state = {
    total: parseInt(pager.dataset.total, 10) || 0,
    perPage: parseInt(pager.dataset.perPage, 10) || 4,
    page: parseInt(pager.dataset.page, 10) || 1,
    cate: pager.dataset.cate || 'danh-sach',
  };
  const fill = (tpl, cate, page) => tpl.replace('{cate}', encodeURIComponent(cate)).replace('{page}', page);
  let ctrl;

  function link(cls, page, label, inner) {
    const a = document.createElement('a');
    a.className = `pager__item ${cls}`;
    a.href = fill(urlTpl, state.cate, page);
    a.dataset.page = page;
    if (label) a.setAttribute('aria-label', label);
    if (inner) a.innerHTML = inner;
    else a.textContent = page;
    return a;
  }

  function render() {
    const pages = Math.max(1, Math.ceil(state.total / state.perPage));
    pager.innerHTML = '';
    if (pages <= 1) return;
    const p = state.page;
    let from = Math.max(1, p - Math.floor(WINDOW / 2));
    const to = Math.min(pages, from + WINDOW - 1);
    from = Math.max(1, to - WINDOW + 1);

    const ico = (name) => `<i class="ico ico--${name}" aria-hidden="true"></i>`;
    const first = link('pager__first', 1, 'Trang đầu', ico('pg-first'));
    const prev = link('pager__prev', Math.max(1, p - 1), 'Trang trước', ico('pg-prev'));
    if (p === 1) [first, prev].forEach((a) => a.classList.add('is-disabled'));
    pager.append(first, prev);
    for (let i = from; i <= to; i += 1) {
      const a = link('pager__num', i, `Trang ${i}`);
      if (i === p) {
        a.classList.add('is-active');
        a.setAttribute('aria-current', 'page');
      }
      pager.appendChild(a);
    }
    const next = link('pager__next', Math.min(pages, p + 1), 'Trang sau', ico('pg-prev'));
    const last = link('pager__last', pages, 'Trang cuối', ico('pg-first'));
    if (p === pages) [next, last].forEach((a) => a.classList.add('is-disabled'));
    pager.append(next, last);
  }

  function syncTabs() {
    $$('.sub-tabs [data-cate]').forEach((t) => {
      const on = t.dataset.cate === state.cate;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'page');
      else t.removeAttribute('aria-current');
    });
  }

  function scrollToList() {
    const head = $('.sub-head');
    const header = $('.mb-header');
    const offset = header && header.offsetParent !== null ? header.getBoundingClientRect().height : 0;
    if (!head) return;
    const top = head.getBoundingClientRect().top + window.scrollY - offset - 10 * ratio();
    if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
  }

  async function load(cate, page, push = true) {
    const url = fill(urlTpl, cate, page);
    if (!endpointTpl) {
      // bản mẫu không có server: chỉ cập nhật giao diện để xem hiệu ứng
      Object.assign(state, { cate, page });
      results.classList.add('is-loading');
      setTimeout(() => results.classList.remove('is-loading'), 250);
    } else {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      results.setAttribute('aria-busy', 'true');
      results.classList.add('is-loading');
      try {
        const html = await fetchCmsHtml(fill(endpointTpl, cate, page), { signal: ctrl.signal });
        const frag = toFragment(html);
        const total = frag.querySelector('#itemTotal');
        const per = frag.querySelector('#itemPerPage');
        Object.assign(state, {
          cate,
          page,
          total: total ? parseInt(total.value, 10) || 0 : state.total,
          perPage: per ? parseInt(per.value, 10) || state.perPage : state.perPage,
        });
        setTimeout(() => {
          results.innerHTML = '';
          results.appendChild(frag);
          results.setAttribute('aria-busy', 'false');
          requestAnimationFrame(() => results.classList.remove('is-loading'));
        }, 200);
      } catch (err) {
        if (err.name !== 'AbortError') window.location.href = url;
        return;
      }
    }
    render();
    syncTabs();
    if (push) window.history.pushState({ cate, page }, '', url);
    scrollToList();
  }

  // bản mẫu: giữ trạng thái theo ?cate=&page= sau khi F5
  if (!endpointTpl) {
    const q = new URLSearchParams(window.location.search);
    if (q.get('cate')) state.cate = q.get('cate');
    if (q.get('page')) state.page = parseInt(q.get('page'), 10) || 1;
  }
  window.history.replaceState({ cate: state.cate, page: state.page }, '');
  render();
  syncTabs();

  pager.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-page]');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    const page = parseInt(a.dataset.page, 10);
    if (page !== state.page) load(state.cate, page);
  });
  $$('.sub-tabs [data-cate]').forEach((tab) => tab.addEventListener('click', (e) => {
    if (e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    if (tab.dataset.cate !== state.cate || state.page !== 1) load(tab.dataset.cate, 1);
  }));
  window.addEventListener('popstate', (e) => {
    if (e.state && e.state.cate) load(e.state.cate, e.state.page, false);
  });
});
